<div>
  <div class="work-shift__tickets-list">
    <div class="tickets-list__wrapper">
      <div class="wrapper__header" #wrapperHeader>
        <div class="tickets-list__header" #ticketsListHeader>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--interval">Интервал</div>
          <div class="tickets-list__item_th tickets-list__item">Район / Адрес</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--type">Тип</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item_th_b">Назначена на бригаду</div>
          <div class="tickets-list__item_th tickets-list__item">Параметры заявки</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--extra">Дополнительно</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--global-problem">ГП на адресе</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--number">Номер</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--status-vk">Статус BK</div>
          <div class="tickets-list__item_th tickets-list__item tickets-list__item--status-hd" style="display: none">Статус HD</div>
        </div>
      </div>
    </div>
    <div class="tickets-list__content pos-r" #ticketsList [style.height.px]="listHeight">
      <div class="padding-24" *ngIf="tickets.ticketsLoading">
        <app-loader></app-loader>
      </div>
      <ng-container *ngIf="!tickets.ticketsLoading">
        <!--                список дат-->
        <ng-container *ngIf="tickets.dataTable && tickets.dataTable.length">
          <div *ngFor="let date of tickets.dataTable">
            <ng-container *ngIf="date.isShow">
              <div class="date__wrapper">
                <div class="date padding-8 bg-blue-light">
                  <span class="title title--s">
                    <span *ngIf="date.date === currentDate">Сегодня</span>
                    <span *ngIf="date.date !== currentDate">
                      {{ date.date | dateFormat: 'DD MMM YYYYг.' }}
                    </span>
                  </span>
                </div>
              </div>

              <!--                            edo tickets-->
              <div class="content__address-intervals mt-2 mb-2" *ngFor="let interval of date.edo_intervals">
                <ng-container *ngIf="interval.isShow">
                  <div class="address-intervals__districts" *ngFor="let district of interval.districts; let index = index">
                    <ng-container *ngIf="district.isShow">
                      <ng-container *ngIf="index === 0">
                        <div class="address-intervals__action">
                          <div class="tickets-list__item tickets-list__item--interval">
                            <div class="grid grid--gap-4">
                              <div class="grid__box grid__box--size-min">
                                <div class="grid" (click)="interval.isOpen = !interval.isOpen">
                                  <div class="grid__box grid__box--size-min" *ngIf="interval.isOpen">
                                    <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                  </div>
                                  <div class="grid__box grid__box--size-min" *ngIf="!interval.isOpen">
                                    <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                  </div>
                                </div>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                <div class="ml-8">
                                  <app-icon [glyph]="'doc'" [size]="'16'" [color]="'gray-dark'"></app-icon>
                                </div>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ interval.ticketsCount }}
                              </div>
                            </div>
                          </div>
                          <div class="tickets-list__item">
                            <div class="grid grid--gap-8 cur-pointer" *ngIf="interval.isOpen" (click)="changeStateOpened(district)">
                              <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ district.district_name }}
                                (<span
                                  [ngClass]="{
                                    'color-green-dark': district.assigned === district.all
                                  }"
                                  >{{ district.assigned }}
                                  /
                                  {{ district.all }}</span
                                >)
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="district.isOpened && interval.isOpen">
                          <div class="address-intervals__ticket" *ngFor="let ticket of district.tickets">
                            <ng-container *ngIf="ticket.isShow">
                              <div class="tickets-list__item tickets-list__item--interval"></div>
                              <div class="tickets-list__item tickets-list__item-address">
                                <div class="grid grid--gap-4">
                                  <div class="grid__box grid__box--size-2">
                                    <app-ticket-checker-new
                                      [ticket]="ticket"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                    ></app-ticket-checker-new>
                                  </div>
                                  <div class="grid__box grid__box--size-9">
                                    {{ ticket.hd_address }}
                                  </div>
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--type">
                                <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
                              </div>
                              <div class="tickets-list__item">
                                <span class="tickets-list__item-brigade">
                                  <div
                                    class="item-brigade"
                                    [ngClass]="{
                                      'pr-8': ticket.brigade
                                    }"
                                  >
                                    <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
                                  </div>
                                  <div
                                    class="item-brigade-assign"
                                    [ngClass]="{
                                      'item-brigade-assign--not-brigade': !ticket.brigade || (isOpenTicketsBrigadeAssignPopover && ticketBrigadePopoverOpen.id === ticket.id)
                                    }"
                                  >
                                    <app-tickets-brigade-assign-new
                                      [ticket]="ticket"
                                      [filter]="filter"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                      [brigadeAssign]="brigadeAssign"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                    ></app-tickets-brigade-assign-new>
                                  </div>
                                </span>
                              </div>
                              <div class="tickets-list__item">
                                <div
                                  [ngClass]="{
                                    'color-red-dark': ticket.isWarnExpDays,
                                    'color-blue-dark': !ticket.isWarnExpDays
                                  }"
                                >
                                  <span>{{ ticket.hd_schedule_intbegin | dateFormat: 'DD.MM.YYYY' }}</span>
                                  &ndash;
                                  <span>{{ ticket.hd_schedule_intend | dateFormat: 'DD.MM.YYYY' }}</span>
                                </div>

                                <div
                                  class="text-ellipsis no-wrap mt-2"
                                  *ngIf="ticket.edo && ticket.edo.brigade_created_contract"
                                  title="{{ ticket.edo.brigade_created_contract.brigade_name }}"
                                >
                                  Оформила
                                  {{ ticket.edo.brigade_created_contract.brigade_name }}
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--extra"></div>
                              <div class="tickets-list__item tickets-list__item--global-problem"></div>
                              <div class="tickets-list__item tickets-list__item--number">
                                <a
                                  class="link {{ 'link--' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}"
                                  [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]"
                                >
                                  {{ ticket.hd_ticket_number }}
                                </a>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-vk">
                                <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                  {{ ticket.ticket_status && ticket.ticket_status.name }}
                                </span>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-hd">
                                {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="index > 0 && interval.isOpen">
                        <div class="address-intervals__action">
                          <div class="tickets-list__item tickets-list__item--interval tickets-list__item--not-hover"></div>
                          <div class="tickets-list__item">
                            <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                              <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ district.district_name }}
                                (
                                <span
                                  [ngClass]="{
                                    'color-green-dark': district.assigned === district.all
                                  }"
                                  >{{ district.assigned }}
                                  /
                                  {{ district.all }}</span
                                >
                                )
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="district.isOpened">
                          <div class="address-intervals__ticket" *ngFor="let ticket of district.tickets">
                            <ng-container *ngIf="ticket.isShow">
                              <div class="tickets-list__item tickets-list__item--interval">
                                <div class="item--interval-date--hover"></div>
                              </div>
                              <div class="tickets-list__item tickets-list__item-address">
                                <div class="grid grid--gap-4">
                                  <div class="grid__box grid__box--size-2">
                                    <app-ticket-checker-new
                                      [ticket]="ticket"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                    ></app-ticket-checker-new>
                                  </div>
                                  <div class="grid__box grid__box--size-9">
                                    {{ ticket.hd_address }}
                                  </div>
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--type">
                                <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
                              </div>
                              <div class="tickets-list__item">
                                <span
                                  [ngClass]="{
                                    'mr-8': ticket.brigade
                                  }"
                                >
                                  <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
                                </span>
                                <app-tickets-brigade-assign-new
                                  [ticket]="ticket"
                                  [filter]="filter"
                                  [ticketsCurrentFilter]="ticketsCurrentFilter"
                                  [brigadeAssign]="brigadeAssign"
                                  [ticketsMultipleAssign]="ticketsMultipleAssign"
                                  (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                ></app-tickets-brigade-assign-new>
                              </div>
                              <div class="tickets-list__item">
                                <div
                                  [ngClass]="{
                                    'color-red-dark': ticket.isWarnExpDays,
                                    'color-blue-dark': !ticket.isWarnExpDays
                                  }"
                                >
                                  <span>{{ ticket.hd_schedule_intbegin | dateFormat: 'DD.MM.YYYY' }}</span>
                                  &ndash;
                                  <span>{{ ticket.hd_schedule_intend | dateFormat: 'DD.MM.YYYY' }}</span>
                                </div>

                                <div
                                  class="text-ellipsis no-wrap mt-2"
                                  *ngIf="ticket.edo && ticket.edo.brigade_created_contract"
                                  title="{{ ticket.edo.brigade_created_contract.brigade_name }}"
                                >
                                  Оформила
                                  {{ ticket.edo.brigade_created_contract.brigade_name }}
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--extra"></div>
                              <div class="tickets-list__item tickets-list__item--global-problem"></div>
                              <div class="tickets-list__item tickets-list__item--number">
                                <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
                                  {{ ticket.hd_ticket_number }}
                                </a>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-vk">
                                <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                  {{ ticket.ticket_status && ticket.ticket_status.name }}
                                </span>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-hd">
                                {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <!--                            /edo tickets-->
              <!--                            gp tickets-->
              <div class="content__address-intervals mt-2 mb-2" *ngFor="let interval of date.gp_intervals">
                <ng-container *ngIf="interval.isShow">
                  <div class="address-intervals__districts" *ngFor="let district of interval.districts; let index = index">
                    <ng-container *ngIf="district.isShow">
                      <ng-container *ngIf="index === 0">
                        <div class="address-intervals__action">
                          <div class="tickets-list__item tickets-list__item--interval">
                            <div class="grid grid--gap-4">
                              <div class="grid__box grid__box--size-min">
                                <div class="grid" (click)="interval.isOpen = !interval.isOpen">
                                  <div class="grid__box grid__box--size-min" *ngIf="interval.isOpen">
                                    <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                  </div>
                                  <div class="grid__box grid__box--size-min" *ngIf="!interval.isOpen">
                                    <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                                  </div>
                                </div>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                <div class="ml-8">
                                  <app-icon [glyph]="'triangle-warning'" [size]="'16'" [color]="'red-dark'"></app-icon>
                                </div>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ interval.ticketsCount }}
                              </div>
                            </div>
                          </div>
                          <div class="tickets-list__item">
                            <div class="grid grid--gap-8 cur-pointer" *ngIf="interval.isOpen" (click)="changeStateOpened(district)">
                              <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ district.district_name }}
                                (<span
                                  [ngClass]="{
                                    'color-green-dark': district.assigned === district.all
                                  }"
                                  >{{ district.assigned }}
                                  /
                                  {{ district.all }}</span
                                >)
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="district.isOpened && interval.isOpen">
                          <div class="address-intervals__ticket" *ngFor="let ticket of district.tickets">
                            <ng-container *ngIf="ticket.isShow">
                              <div class="tickets-list__item tickets-list__item--interval">
                                <div class="item--interval-date--hover">
                                  {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                  -
                                  {{ interval.int_end | dateFormat: 'HH:mm' }}
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item-address">
                                <div class="grid grid--gap-4">
                                  <div class="grid__box grid__box--size-2">
                                    <app-ticket-checker-new
                                      [ticket]="ticket"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                    ></app-ticket-checker-new>
                                  </div>
                                  <div class="grid__box grid__box--size-9">
                                    {{ ticket.hd_address }}
                                  </div>
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--type">
                                <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
                              </div>
                              <div class="tickets-list__item">
                                <span class="tickets-list__item-brigade">
                                  <div
                                    class="item-brigade"
                                    [ngClass]="{
                                      'pr-8': ticket.brigade
                                    }"
                                  >
                                    <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
                                  </div>
                                  <div
                                    class="item-brigade-assign"
                                    [ngClass]="{
                                      'item-brigade-assign--not-brigade': !ticket.brigade || (isOpenTicketsBrigadeAssignPopover && ticketBrigadePopoverOpen.id === ticket.id)
                                    }"
                                  >
                                    <app-tickets-brigade-assign-new
                                      [ticket]="ticket"
                                      [filter]="filter"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                      [brigadeAssign]="brigadeAssign"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                    ></app-tickets-brigade-assign-new>
                                  </div>
                                </span>
                              </div>
                              <div class="tickets-list__item">
                                <div
                                  class="text-ellipsis"
                                  title="{{ ticket.ticket_subtype }}"
                                  style="width: 167px"
                                  *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 3) || ticket.ticket_type.id === 4"
                                >
                                  {{ ticket.ticket_subtype }}
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && !ticket.extra_flags.moveaddr">
                                  <span class="color-red-dark">Нет сервисов</span>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id !== 1">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && ticket.extra_flags.moveaddr">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 2">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--extra tickets-list__item--indent">
                                <div class="grid grid--gap-4" *ngIf="ticket.ticket_type.id !== 4">
                                  <div
                                    class="grid__box grid__box--size-min tickets-list__item--indent"
                                    *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 1) || ticket.ticket_type.id === 2 || ticket.ticket_type.id === 3"
                                  >
                                    <span class="cursor-pointer" (click)="refreshLineStatus(ticket, $event)" *ngIf="ticket.hd_line_status_info != null">
                                      <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                                      <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
                                    </span>
                                  </div>
                                  <div class="grid__box grid__box--size-min">
                                    <app-tickets-extra-new [ticket]="ticket"></app-tickets-extra-new>
                                  </div>
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 4">
                                  <app-ticket-communicator-info-new [ticket]="ticket"></app-ticket-communicator-info-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--global-problem">
                                <app-ticket-global-problem-check-new [ticket]="ticket"></app-ticket-global-problem-check-new>
                              </div>
                              <div class="tickets-list__item tickets-list__item--number">
                                <a
                                  class="link {{ 'link--' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}"
                                  [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]"
                                >
                                  {{ ticket.hd_ticket_number }}
                                </a>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-vk">
                                <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                  {{ ticket.ticket_status && ticket.ticket_status.name }}
                                </span>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-hd">
                                {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="index > 0 && interval.isOpen">
                        <div class="address-intervals__action">
                          <div class="tickets-list__item tickets-list__item--interval tickets-list__item--not-hover"></div>
                          <div class="tickets-list__item">
                            <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                              <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ district.district_name }}
                                (
                                <span
                                  [ngClass]="{
                                    'color-green-dark': district.assigned === district.all
                                  }"
                                  >{{ district.assigned }}
                                  /
                                  {{ district.all }}</span
                                >
                                )
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="district.isOpened">
                          <div class="address-intervals__ticket" *ngFor="let ticket of district.tickets">
                            <ng-container *ngIf="ticket.isShow">
                              <div class="tickets-list__item tickets-list__item--interval">
                                <div class="item--interval-date--hover">
                                  {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                  -
                                  {{ interval.int_end | dateFormat: 'HH:mm' }}
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item-address">
                                <div class="grid grid--gap-4">
                                  <div class="grid__box grid__box--size-2">
                                    <app-ticket-checker-new
                                      [ticket]="ticket"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                    ></app-ticket-checker-new>
                                  </div>
                                  <div class="grid__box grid__box--size-9">
                                    {{ ticket.hd_address }}
                                  </div>
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--type">
                                <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
                              </div>
                              <div class="tickets-list__item">
                                <span
                                  [ngClass]="{
                                    'mr-8': ticket.brigade
                                  }"
                                >
                                  <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
                                </span>
                                <app-tickets-brigade-assign-new
                                  [ticket]="ticket"
                                  [filter]="filter"
                                  [ticketsCurrentFilter]="ticketsCurrentFilter"
                                  [brigadeAssign]="brigadeAssign"
                                  [ticketsMultipleAssign]="ticketsMultipleAssign"
                                  (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                ></app-tickets-brigade-assign-new>
                              </div>
                              <div class="tickets-list__item">
                                <div
                                  class="text-ellipsis cur-help"
                                  title="{{ ticket.ticket_subtype }}"
                                  style="width: 167px"
                                  *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 3) || ticket.ticket_type.id === 4"
                                >
                                  {{ ticket.ticket_subtype }}
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && !ticket.extra_flags.moveaddr">
                                  <span class="color-red-dark">Нет сервисов</span>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id !== 1">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && ticket.extra_flags.moveaddr">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 2">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--extra">
                                <div class="grid grid--gap-4">
                                  <div
                                    class="grid__box grid__box--size-min tickets-list__item--indent"
                                    *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 1) || ticket.ticket_type.id === 2 || ticket.ticket_type.id === 3"
                                  >
                                    <span class="cursor-pointer" (click)="refreshLineStatus(ticket, $event)" *ngIf="ticket.hd_line_status_info != null">
                                      <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                                      <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
                                    </span>
                                  </div>
                                  <div class="grid__box grid__box--size-min">
                                    <app-tickets-extra-new [ticket]="ticket"></app-tickets-extra-new>
                                  </div>
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 4">
                                  <app-ticket-communicator-info-new [ticket]="ticket"></app-ticket-communicator-info-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--global-problem">
                                <app-ticket-global-problem-check-new [ticket]="ticket"></app-ticket-global-problem-check-new>
                              </div>
                              <div class="tickets-list__item tickets-list__item--number">
                                <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
                                  {{ ticket.hd_ticket_number }}
                                </a>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-vk">
                                <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                  {{ ticket.ticket_status && ticket.ticket_status.name }}
                                </span>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-hd">
                                {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <!--                            /gp tickets-->
              <!--                            other tickets-->
              <div class="content__address-intervals" *ngFor="let interval of date.intervals">
                <ng-container *ngIf="interval.isShow">
                  <div class="address-intervals__districts" *ngFor="let district of interval.districts; let index = index">
                    <ng-container *ngIf="district.isShow">
                      <ng-container *ngIf="index === 0">
                        <div class="address-intervals__action">
                          <div class="tickets-list__item tickets-list__item--interval">
                            <span>
                              {{ interval.int_begin | dateFormat: 'HH:mm' }}
                              -
                              {{ interval.int_end | dateFormat: 'HH:mm' }}
                            </span>
                          </div>
                          <div class="tickets-list__item">
                            <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                              <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ district.district_name }}
                                (<span
                                  [ngClass]="{
                                    'color-green-dark': district.assigned === district.all
                                  }"
                                  >{{ district.assigned }}
                                  /
                                  {{ district.all }}</span
                                >)
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="district.isOpened">
                          <div class="address-intervals__ticket" *ngFor="let ticket of district.tickets">
                            <ng-container *ngIf="ticket.isShow">
                              <div class="tickets-list__item tickets-list__item--interval">
                                <div class="item--interval-date--hover">
                                  {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                  -
                                  {{ interval.int_end | dateFormat: 'HH:mm' }}
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item-address">
                                <div class="grid grid--gap-4">
                                  <div class="grid__box grid__box--size-2">
                                    <app-ticket-checker-new
                                      [ticket]="ticket"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                    ></app-ticket-checker-new>
                                  </div>
                                  <div class="grid__box grid__box--size-9">
                                    {{ ticket.hd_address }}
                                  </div>
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--type">
                                <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
                              </div>
                              <div class="tickets-list__item">
                                <span class="tickets-list__item-brigade">
                                  <div
                                    class="item-brigade"
                                    [ngClass]="{
                                      'pr-8': ticket.brigade
                                    }"
                                  >
                                    <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
                                  </div>
                                  <div
                                    class="item-brigade-assign"
                                    [ngClass]="{
                                      'item-brigade-assign--not-brigade': !ticket.brigade || (isOpenTicketsBrigadeAssignPopover && ticketBrigadePopoverOpen.id === ticket.id)
                                    }"
                                  >
                                    <app-tickets-brigade-assign-new
                                      [ticket]="ticket"
                                      [filter]="filter"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                      [brigadeAssign]="brigadeAssign"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                    ></app-tickets-brigade-assign-new>
                                  </div>
                                </span>
                              </div>
                              <div class="tickets-list__item">
                                <div class="tickets-list__text">
                                  <ng-container *ngIf="ticket.hd_ticket_type.id === 218">
                                    <app-icon [glyph]="'giga'" [size]="'22'" [color]="'gray-dark'"></app-icon>
                                  </ng-container>

                                  <div
                                    class="text-ellipsis"
                                    title="{{ ticket.ticket_subtype }}"
                                    style="width: 205px"
                                    *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 3) || ticket.ticket_type.id === 4"
                                  >
                                    {{ ticket.ticket_subtype }}
                                  </div>
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && !ticket.extra_flags.moveaddr">
                                  <span class="color-red-dark">Нет сервисов</span>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id !== 1">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && ticket.extra_flags.moveaddr">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 2">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--extra">
                                <div class="grid grid--gap-4">
                                  <div
                                    class="grid__box grid__box--size-min tickets-list__item--indent"
                                    *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 1) || ticket.ticket_type.id === 2 || ticket.ticket_type.id === 3"
                                  >
                                    <span class="cursor-pointer" (click)="refreshLineStatus(ticket, $event)" *ngIf="ticket.hd_line_status_info != null">
                                      <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                                      <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
                                    </span>
                                  </div>
                                  <div class="grid__box grid__box--size-min">
                                    <app-tickets-extra-new [ticket]="ticket"></app-tickets-extra-new>
                                  </div>
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 4">
                                  <app-ticket-communicator-info-new [ticket]="ticket"></app-ticket-communicator-info-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--global-problem">
                                <app-ticket-global-problem-check-new [ticket]="ticket"></app-ticket-global-problem-check-new>
                              </div>
                              <div class="tickets-list__item tickets-list__item--number">
                                <a
                                  class="link {{ 'link--' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}"
                                  [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]"
                                >
                                  {{ ticket.hd_ticket_number }}
                                </a>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-vk">
                                <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                  {{ ticket.ticket_status && ticket.ticket_status.name }}
                                </span>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-hd">
                                {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="index > 0">
                        <div class="address-intervals__action">
                          <div class="tickets-list__item tickets-list__item--interval tickets-list__item--not-hover"></div>
                          <div class="tickets-list__item">
                            <div class="grid grid--gap-8 cur-pointer" (click)="changeStateOpened(district)">
                              <div class="grid__box grid__box--size-min" *ngIf="district.isOpened">
                                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min" *ngIf="!district.isOpened">
                                <app-icon [glyph]="'arrow-top'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                              </div>
                              <div class="grid__box grid__box--size-min">
                                {{ district.district_name }}
                                (
                                <span
                                  [ngClass]="{
                                    'color-green-dark': district.assigned === district.all
                                  }"
                                  >{{ district.assigned }}
                                  /
                                  {{ district.all }}</span
                                >
                                )
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="district.isOpened">
                          <div class="address-intervals__ticket" *ngFor="let ticket of district.tickets">
                            <ng-container *ngIf="ticket.isShow">
                              <div class="tickets-list__item tickets-list__item--interval">
                                <div class="item--interval-date--hover">
                                  {{ interval.int_begin | dateFormat: 'HH:mm' }}
                                  -
                                  {{ interval.int_end | dateFormat: 'HH:mm' }}
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item-address">
                                <div class="grid grid--gap-4">
                                  <div class="grid__box grid__box--size-2">
                                    <app-ticket-checker-new
                                      [ticket]="ticket"
                                      [ticketsMultipleAssign]="ticketsMultipleAssign"
                                      [ticketsCurrentFilter]="ticketsCurrentFilter"
                                    ></app-ticket-checker-new>
                                  </div>
                                  <div class="grid__box grid__box--size-9">
                                    {{ ticket.hd_address }}
                                  </div>
                                </div>
                              </div>
                              <div class="tickets-list__item tickets-list__item--type">
                                <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
                              </div>
                              <div class="tickets-list__item">
                                <span
                                  [ngClass]="{
                                    'mr-8': ticket.brigade
                                  }"
                                >
                                  <app-brigade-popover [brigade]="ticket.brigade"></app-brigade-popover>
                                </span>
                                <app-tickets-brigade-assign-new
                                  [ticket]="ticket"
                                  [filter]="filter"
                                  [ticketsCurrentFilter]="ticketsCurrentFilter"
                                  [brigadeAssign]="brigadeAssign"
                                  [ticketsMultipleAssign]="ticketsMultipleAssign"
                                  (onOpen)="onOpenTicketBrigadeAssignPopover($event)"
                                ></app-tickets-brigade-assign-new>
                              </div>
                              <div class="tickets-list__item">
                                <div
                                  class="text-ellipsis cur-help"
                                  title="{{ ticket.ticket_subtype }}"
                                  style="width: 205px"
                                  *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 3) || ticket.ticket_type.id === 4"
                                >
                                  {{ ticket.ticket_subtype }}
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && !ticket.extra_flags.moveaddr">
                                  <span class="color-red-dark">Нет сервисов</span>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id !== 1">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && ticket.extra_flags.moveaddr">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                                <ng-container *ngIf="ticket.ticket_type.id === 2">
                                  <app-tickets-services-new [services]="ticket.services" [ticket]="ticket"></app-tickets-services-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--extra">
                                <div class="grid grid--gap-4">
                                  <div
                                    class="grid__box grid__box--size-min tickets-list__item--indent"
                                    *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 1) || ticket.ticket_type.id === 2 || ticket.ticket_type.id === 3"
                                  >
                                    <span class="cursor-pointer" (click)="refreshLineStatus(ticket, $event)" *ngIf="ticket.hd_line_status_info != null">
                                      <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                                      <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
                                    </span>
                                  </div>
                                  <div class="grid__box grid__box--size-min">
                                    <app-tickets-extra-new [ticket]="ticket"></app-tickets-extra-new>
                                  </div>
                                </div>
                                <ng-container *ngIf="ticket.ticket_type.id === 4">
                                  <app-ticket-communicator-info-new [ticket]="ticket"></app-ticket-communicator-info-new>
                                </ng-container>
                              </div>
                              <div class="tickets-list__item tickets-list__item--global-problem">
                                <app-ticket-global-problem-check-new [ticket]="ticket"></app-ticket-global-problem-check-new>
                              </div>
                              <div class="tickets-list__item tickets-list__item--number">
                                <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticket.id]">
                                  {{ ticket.hd_ticket_number }}
                                </a>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-vk">
                                <span class="{{ 'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id] }}">
                                  {{ ticket.ticket_status && ticket.ticket_status.name }}
                                </span>
                              </div>
                              <div class="tickets-list__item tickets-list__item--status-hd">
                                {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <!--                            /other tickets-->
            </ng-container>
          </div>
        </ng-container>
        <!--                / список дат-->

        <ng-container *ngIf="tickets.data && !tickets.data.length">
          <div class="padding-24 ta-center text-italic color-gray-dark">"Заявки по заданным критериям не найдены".</div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
